/* @flow */
import GroupMembership from 'entities/GroupMembership';
import API from 'lib/RemindAPI';

type Sort = 'first_name' | 'last_name' | 'join_date' | 'role';
type SortDirection = 'desc' | 'asc';

export type ClassMembershipFetchOptions = {
  page: number,
  perPage: number,
  sortDirection?: SortDirection,
  userIds?: number[],
  sort?: Sort,
  roles?: string[],
  query?: string,
};

export type RootGroupMembershipFetchOptions = {
  page: number,
  perPage: number,
  query?: string,
};

export function fetchMembership(groupId: Backbone$Id, userId: Backbone$Id) {
  return API.request(`/classes/${groupId}/members/${userId}`, 'GET').then(response =>
    GroupMembership.fromJSON(response)
  );
}

export function fetchMemberships(groupId: Backbone$Id, parameters: ClassMembershipFetchOptions) {
  const options = {
    sort_type: parameters.sort,
    per_page: parameters.perPage,
    user_ids: parameters.userIds,
    sort_direction: parameters.sortDirection,
    roles: parameters.roles,
    page: parameters.page,
    q: parameters.query,
  };

  return API.request(`/classes/${groupId}/members`, 'GET', options).then(response =>
    response.members.map(member => GroupMembership.fromJSON(member))
  );
}

export function fetchRootGroupMemberships(parameters: RootGroupMembershipFetchOptions) {
  const options = {
    per_page: parameters.perPage,
    page: parameters.page,
    q: parameters.query,
  };

  return API.request(`/chats/members/potential`, 'GET', options).then(response =>
    response.map(member => GroupMembership.fromJSON(member))
  );
}
